<template>
  <div class="relative pt-5">
    <div class="absolute -top-12 right-0">
      <input
        @click="AddHandler()"
        type="button"
        value="Add New Entry"
        class="px-6 py-3 bg-orange-400 text-sm text-white font-medium rounded-sm cursor-pointer hover:bg-orange-700 transition"
      />
    </div>

    <!-- Main Card -->
    <div
      class="min-h-8 p-4 bg-white shadow-[0_2px_8px_rgba(0,0,0,0.15)] rounded-lg"
    >
      <SectionTransaction
        :isReload="isSucces"
        @done-reload="handleReload"
        @renderUpdate="handleRenderUpdate"
      />
    </div>
    <ApplicationModal
      :modalTrigger="isActiveModal"
      :ifCurrentMode="currentFormMode"
      :renderDataItems="renderData"
      @close="isActiveModal = false"
      @success="getValue"
    />
  </div>
</template>
<script>
import ApplicationModal from "@/components/partial/Application/SectionApplication.vue";
import SectionTransaction from "@/components/partial/Application/SectionTransaction.vue";

import { ref } from "vue";
export default {
  components: {
    ApplicationModal,
    SectionTransaction,
  },
  setup() {
    const isActiveModal = ref(false);
    const isSucces = ref(false);
    const currentFormMode = ref("add");
    const renderData = ref([]);

    const AddHandler = () => {
      isActiveModal.value = true;
      currentFormMode.value = "add";
    };
    const getValue = (val) => {
      isSucces.value = val;
    };
    const handleReload = () => {
      isSucces.value = false;
    };
    const handleRenderUpdate = (val, payLoad) => {
      isActiveModal.value = val;
      currentFormMode.value = "edit";
      renderData.value = payLoad;
    };
    return {
      isActiveModal,
      AddHandler,
      getValue,
      isSucces,
      currentFormMode,
      handleReload,
      handleRenderUpdate,
      renderData,
    };
  },
};
</script>
